import React from 'react'

const DefaultContent = ({ containerObject }) => {
    return (
        <>
        <p>DefaultContent</p>
            {containerObject && containerObject.targeterResult ? <div dangerouslySetInnerHTML={{ __html: containerObject.targeterResult }}  ></div> : ""}

        </>
    )
}

export default DefaultContent